import { stableFingerprint } from './random.js';
export function fingerprintDungeonMaterial(material) {
    return stableFingerprint(material);
}
export function fingerprintDungeonPlan(plan) {
    const material = { ...plan };
    delete material.id;
    delete material.fingerprint;
    return stableFingerprint(material);
}
//# sourceMappingURL=fingerprint.js.map